import { z } from "zod";
import { Created, Id, IsoDate, Ok, OptionalText } from "./common";
import { defineRoutes } from "./define";
import { PROBLEMS } from "./problem";

/** A competition / start ("старт") a patient is preparing for. */
export const CompetitionListItem = z.object({
  id: Id,
  title: z.string(),
  /** YYYY-MM-DD. */
  date: z.string(),
  comment: z.string().nullable(),
});
export type CompetitionListItem = z.infer<typeof CompetitionListItem>;

export const CompetitionBody = z.object({
  title: z.string().trim().min(1, "Назва старту обовʼязкова").max(200),
  date: IsoDate,
  comment: OptionalText(2000),
});
export type CompetitionBody = z.infer<typeof CompetitionBody>;

export const competitions = defineRoutes({
  list: {
    method: "GET",
    path: "/patients/:patientId/competitions",
    summary: "A patient's competitions, soonest first",
    params: z.object({ patientId: Id }),
    responses: { 200: z.array(CompetitionListItem), 401: PROBLEMS[401], 403: PROBLEMS[403] },
  },
  create: {
    method: "POST",
    path: "/patients/:patientId/competitions",
    summary: "Add a competition",
    params: z.object({ patientId: Id }),
    body: CompetitionBody,
    responses: {
      201: Created,
      400: PROBLEMS[400],
      401: PROBLEMS[401],
      403: PROBLEMS[403],
      422: PROBLEMS[422],
    },
  },
  update: {
    method: "PATCH",
    path: "/competitions/:competitionId",
    summary: "Edit a competition",
    params: z.object({ competitionId: Id }),
    body: CompetitionBody,
    responses: {
      200: CompetitionListItem,
      400: PROBLEMS[400],
      401: PROBLEMS[401],
      403: PROBLEMS[403],
      404: PROBLEMS[404],
      422: PROBLEMS[422],
    },
  },
  delete: {
    method: "DELETE",
    path: "/competitions/:competitionId",
    summary: "Soft-delete a competition",
    params: z.object({ competitionId: Id }),
    responses: { 200: Ok, 401: PROBLEMS[401], 403: PROBLEMS[403], 404: PROBLEMS[404] },
  },
});
